import React from 'react'

// Placeholders use the real card classes so spacing and radius match and nothing jumps on swap.
const bar = (width, height, extra = {}) => ({ width, height, borderRadius: 6, ...extra })

export function ArchiveCardSkeleton({ variant = 0 }) {
    return (
        <div className="archive-card archive-card--skeleton" aria-hidden="true">
            <div className="archive-card-head">
                <div className="archive-skel animate-pulse" style={bar(28, 28, { borderRadius: '50%' })} />
                <div className="archive-skel animate-pulse" style={bar(84, 12)} />
                <div style={{ flex: 1 }} />
                <div className="archive-skel animate-pulse" style={bar(36, 12)} />
            </div>
            <div className="archive-card-body">
                <div className="archive-skel animate-pulse" style={bar('70%', 18, { marginBottom: 10 })} />
                <div className="archive-skel animate-pulse" style={bar('92%', 12, { marginBottom: 6 })} />
                <div className="archive-skel animate-pulse" style={bar('48%', 12, { marginBottom: 16 })} />
                {variant % 2 === 0 ? (
                    <>
                        <div className="archive-skel archive-skel--soft animate-pulse" style={bar('100%', 40, { borderRadius: 12, marginBottom: 8 })} />
                        <div className="archive-skel archive-skel--soft animate-pulse" style={bar('100%', 40, { borderRadius: 12 })} />
                    </>
                ) : (
                    <div className="archive-skel archive-skel--soft animate-pulse" style={bar('100%', 72, { borderRadius: 12 })} />
                )}
            </div>
        </div>
    )
}

export default function ArchiveSkeleton({ count = 3 }) {
    return (
        <div className="archive-skeleton" role="status" aria-busy="true">
            <div className="archive-day">
                <div className="archive-skel archive-skel--day animate-pulse" style={bar(96, 14, { margin: '4px auto 14px' })} />
            </div>
            {Array.from({ length: count }).map((_, i) => (
                <ArchiveCardSkeleton key={i} variant={i} />
            ))}
        </div>
    )
}
